import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbAuthService, NbLoginComponent, NB_AUTH_OPTIONS } from '@nebular/auth';
import { FormsModule } from '@angular/forms';
import { LoginService } from '../../@core/data-service/login-service';
import { TransactionResult } from '../../@core/data/transaction-result';
import { MessageManagementService } from 'app/@core/services/message-management.service';
import { environment } from '../../../environments/environment';
import { ISite } from '../../@core/data/ISite';
import { ClientService } from '../../@core/data-service/client-service';
import { IClient } from '../../@core/data/IClient';

@Component({
  selector: 'ngx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends NbLoginComponent {
  redirectDelay: number = 0;
  showMessages: any = {};
  strategy: string = '';
  appName: string = environment.appName;
  logo: string = "";

  errors: string[] = [];
  messages: string[] = [];
  user: IUserLogIn;
  submitted: boolean = false;
  rememberMe = false;
  loading: boolean = false;
  siteList: Array<ISite> = [];
  enabledControl: boolean = false;
  client: IClient;
  @ViewChild("password") password: ElementRef;

  constructor(protected service: NbAuthService,
    protected loginService: LoginService,
    @Inject(NB_AUTH_OPTIONS) protected options = {},
    protected cd: ChangeDetectorRef,
    protected router: Router,
    private messageService: MessageManagementService,
    private clientService: ClientService,
    private route: ActivatedRoute
  ) {
    super(service, options, cd, router);

    if (!this.route.snapshot.params.client) {
      alert("No hay cliente configurado en la Url");
      this.router.navigate(['/auth/login', ""]);
    }


    this.user = {username: "", password: "", siteId: 0, clientId: 0, clientName: ""};

    this.getClient();
  }

  login(): void {
    this.errors = [];
    this.messages = [];
    this.submitted = true;
    this.loading = true;

    this.user.clientId = this.client.id;
    this.user.clientName = this.client.name;
    this.loginService.login(this.user).subscribe(
      (result: TransactionResult<string>) => {
        this.loading = false;
        this.messageService.showMessage(result, false);
        if (result.success) {
          let site: ISite = this.siteList.find(p => p.id == this.user.siteId);
          this.loginService.generateAuthentication(result.data, this.client.name, site.name, this.client.code, this.client.logo);
        }
      },
      (error: any) => {
        this.loading = false;
        this.messageService.error('Error Genérico, reportalo a proveedor',[error.message]);
      }
    );
  }

  getClient(): void {
    this.loading = true;
    this.clientService.getClientByCode(this.route.snapshot.params.client).subscribe(
      (result: TransactionResult<IClient>) => {
        this.loading = false;
        this.messageService.showMessage(result, false);
        if (result.success) {
          if (result.data) {
            this.client = result.data;
            this.appName = this.client.name;
            this.logo = result.data.logo;
          }
        }
        else
          this.router.navigate(['/auth/login', ""]);
      },
      (error: any) => {
        this.loading = false;
        this.messageService.error('Error Genérico, reportalo a proveedor', [error.message]);
      }
    );
  }

  validateUser(): void {
    if (this.user.username) {
      this.loading = true;
      this.loginService.getSitesByUser(this.client.id, this.user.username).subscribe(
        (result: TransactionResult<ISite[]>) => {
          this.loading = false;
          this.messageService.showMessage(result, false);
          if (result.success) {
            this.siteList = result.data;
            if (this.siteList && this.siteList.length > 0) {
              this.user.siteId = this.siteList[0].id;
            }
            this.enabledControl = true;
            setTimeout(() => {
              this.password.nativeElement.focus();
            }, 500);
          }
          else
            this.enabledControl = false;
        },
        (error: any) => {
          this.loading = false;
          this.messageService.error('Error Genérico, reportalo a proveedor', [error.message]);
        }
      );
    }
  }
}

export interface IUserLogIn {
  username: string;
  password: string;
  siteId: number;
  clientId: number;
  clientName: string;
}
